module.exports = __webpack_public_path__ + "img/icon-thumbs-up-fill.2fdc3dc3.svg";